import { createMuiTheme } from "@material-ui/core/styles";
import { blueGrey, grey, red } from "@material-ui/core/colors";

let lightTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#024D7C"
    },
    secondary: {
      main: "#F4B793"
    },
    text: {
      main: blueGrey[900],
      disabled: blueGrey[300]
    },
    lines: {
      divisionDark: grey[900],
      division: grey[400],
      divisionLight: grey[200]
    },
    background: {
      default: "white",
      defaultGradient:
        "linear-gradient(180deg, rgba(255,255,255,1) 50%, rgba(234,229,225,1) 100%)"
    },
    jamii: {
      mildBlue: "#658DC3",
      lightBlue: "#B2C4D1",
      brown: "#A68D7F",
      yellow: "#F1D7AD",
      grey: "#858B8B",
      orange: "#F4B793",
      lightGrey: "#EAE5E1",
      darkAccent: "#262525",
      lightAccent: "#EFEEEE"
    },
    extras: {
      red: red[300],
      strongRed: red[500]
    }
  },
  typography: {
    fontWeightMedium: 600,
    fontFamily: "Montserrat",
    smallCaption: {
      fontFamily: "Montserrat",
      fontWeight: 400,
      fontSize: "0.6rem",
      lineHeight: "1.66"
    },
    extraSmallCaption: {
      fontFamily: "Montserrat",
      fontWeight: 400,
      fontSize: "0.5rem",
      lineHeight: "1.66"
    }
  },
  customShadows: color => `3px 4px 0px ${color}`
});

const darkTheme = createMuiTheme({});

export { lightTheme, darkTheme };
